<script>
export default {
  name: 'ChLoadingSpinner',
};
</script>

<template>
  <span class="ch-loading">
    <svg
      class="ch-loading__spinner"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      aria-hidden="true"
    >
      <g fill="#FF8638">
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="1"
          transform="rotate(0 12 12)"
        />
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="0.87"
          transform="rotate(45 12 12)"
        />
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="0.75"
          transform="rotate(90 12 12)"
        />
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="0.62"
          transform="rotate(135 12 12)"
        />
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="0.5"
          transform="rotate(180 12 12)"
        />
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="0.37"
          transform="rotate(225 12 12)"
        />
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="0.25"
          transform="rotate(270 12 12)"
        />
        <rect
          x="10.8"
          y="1.5"
          width="2.4"
          height="6"
          rx="1.2"
          opacity="0.15"
          transform="rotate(315 12 12)"
        />
      </g>
    </svg>
  </span>
</template>

<style scoped lang="scss">
.ch-loading {
  @apply inline-flex items-center justify-center;
}

.ch-loading__spinner {
  @apply w-6 h-6;
  transform-origin: center;
  animation: ch-loading-spin 0.9s steps(8) infinite;
}

@keyframes ch-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
